import i18next from 'i18next';

export const buildLocalizeRoute = (path, language = null) => {
	return `/${language || i18next.language || 'en'}/${path}`;
};
